import {Observable} from 'rxjs';
import {palipaliAuthAPI} from '../provider/palipaliAuth';
import {RestQueryParams} from '../base/queryParams';
import {IAuthTokens} from '../../store/reducers/authSlice';
import {IApiSingleResponseBase} from '../../types';

export function createRefreshTokenAPI(refreshToken: string): Observable<IApiSingleResponseBase<IAuthTokens>> {
    return palipaliAuthAPI.post(`api/auth/refresh?refresh_token=${refreshToken}`, {}, new RestQueryParams());
}
